<template>
  <component-wrapper class="data-privacy-fi">
    <experience-editor-component
      v-if="isEditMode"
      :fields="fields"
    />

    <template v-else-if="!isLoading">
      <grid-container-fi v-if="dataPrivacyHTML">
        <div
          class="fi-col-start-1 fi-col-end-13 md:fi-col-start-2 md:fi-col-end-12 lg:fi-col-start-3 lg:fi-col-end-11"
        >
          <richtext-fi>
            <!-- eslint-disable vue/no-v-html -->
            <div
              class="data-privacy-fi__content"
              v-html="dataPrivacyHTML"
            />
            <!-- eslint-enable vue/no-v-html -->
          </richtext-fi>
        </div>
      </grid-container-fi>
    </template>

    <loading-indicator
      v-else
      variant="spinnerLocal"
    />
  </component-wrapper>
</template>

<script setup lang="ts">
import { ExperienceEditorComponent, LoadingIndicator, RichtextFi } from 'atoms';
import { computed, onMounted, ref } from 'vue';

import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import { useFischer } from '@/composables/fischerPlugin';
import type { DataPrivacyFiFields } from '@/generated/fields';

defineOptions({ name: 'DataPrivacyFi' });

const props = withDefaults(
  defineProps<{
    fields?: DataPrivacyFiFields;
  }>(),
  {
    fields: () => ({}) as DataPrivacyFiFields,
  },
);

const fischer = useFischer();

const isLoading = ref(true);
const dataPrivacyHTML = ref<string | null>(null);
const jumpmarkReady = ref<Promise<void> | null>(null);

const documentId = computed(() => props.fields?.documentId?.value);

async function loadData() {
  try {
    const response = await fetch(`https://api.fischer.group/privacy-policies/${documentId.value}`);
    if (!response.ok) throw new Error(`Could not fetch privacy policies: ${response.status}`);
    const data = await response.text();

    if (data) {
      dataPrivacyHTML.value = data.replace('<h2>', '<h1>').replace('</h2>', '</h1>');
    }
  } catch (error) {
    console.error(error);
  }

  isLoading.value = false;
}

onMounted(() => {
  if (documentId.value && !fischer.app.isEditMode()) {
    jumpmarkReady.value = loadData();
  } else {
    console.error('missing documentId for data privacy api');
  }
});
</script>

<style scoped src="./data-privacy-fi" />
